// src/main.tsx
import { render } from "react-dom";
import Dashboard from "./pages/Dashboard";

render(<Dashboard />, document.getElementById("root"));
